/**
 * Validacao de CPF e CNPJ pelo digito verificador.
 *
 * `nucleo/formato/documentos.ts` so mascara — nao valida, de proposito (ver o
 * comentario de topo daquele arquivo). Este arquivo e "outra conversa": mora nos
 * formularios de cadastro, o unico lugar que precisa recusar um documento
 * matematicamente invalido antes de deixar a pessoa prosseguir.
 */

import { somenteDigitos } from '@/nucleo/formato/documentos';
import type { TipoDeCredenciado } from '@/nucleo/pessoaNatureza';

export function validarCpf(valor: string): boolean {
  const cpf = somenteDigitos(valor);
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
    return false;
  }

  let soma = 0;
  for (let i = 0; i < 9; i += 1) {
    soma += Number(cpf[i]) * (10 - i);
  }
  let resto = (soma * 10) % 11;
  if (resto === 10) {
    resto = 0;
  }
  if (resto !== Number(cpf[9])) {
    return false;
  }

  soma = 0;
  for (let i = 0; i < 10; i += 1) {
    soma += Number(cpf[i]) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10) {
    resto = 0;
  }
  return resto === Number(cpf[10]);
}

export function validarCnpj(valor: string): boolean {
  const cnpj = somenteDigitos(valor);
  if (cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) {
    return false;
  }

  const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesos2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  let soma = 0;
  for (let i = 0; i < 12; i += 1) {
    soma += Number(cnpj[i]) * pesos1[i]!;
  }
  let resto = soma % 11;
  const d1 = resto < 2 ? 0 : 11 - resto;
  if (Number(cnpj[12]) !== d1) {
    return false;
  }

  soma = 0;
  for (let i = 0; i < 13; i += 1) {
    soma += Number(cnpj[i]) * pesos2[i]!;
  }
  resto = soma % 11;
  const d2 = resto < 2 ? 0 : 11 - resto;
  return Number(cnpj[13]) === d2;
}

/** Decide pelo tipo de pessoa. Cooperativa valida como CNPJ. */
export function validarCpfCnpj(valor: string, tipo: TipoDeCredenciado): boolean {
  return tipo === 'PF' ? validarCpf(valor) : validarCnpj(valor);
}
